import {gql} from "graphql-tag";
import {responseField} from "../../../base.graphql";

export const permissionFields = `
id
uniqueId
permissionName
permissionCode
isGlobal
permissionCreateddate
`;

export const userRoleFields = `
id
uniqueId
roleName
roleIsSuperAdmin
roleDescription
roleCreateddate
permissions {
    ${permissionFields}
}
`;

export const CREATE_USER_ROLES_MUTATION = gql`
    mutation createUserRolesMutation($input: UserRolesInput!) {
        createUserRolesMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${userRoleFields}
            }
        }
    }
`;

export const UPDATE_USER_ROLES_MUTATION = gql`
    mutation updateUserRolesMutation($input: UserRolesInput!) {
        updateUserRolesMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${userRoleFields}
            }
        }
    }
`;

export const DELETE_USER_ROLES_MUTATION = gql`
    mutation deleteUserRolesMutation($uniqueId: String!) {
        deleteUserRolesMutation(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }
`;

export const SEED_USER_PERMISSIONS_MUTATION = gql`
    mutation SeedUserPermissionsMutation {
        seedUserPermissionsMutation {
            response {
                ${responseField}
            }
        }
    }
`;

export const GET_ALL_SYSTEM_USER_ROLES = gql`
    query GetAllSystemUserRoles($uniqueId: String) {
        getAllSystemUserRoles(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
            data {
                ${userRoleFields}
            }
        }
    }
`;

export const GET_ROLES_QUERY = gql`
    query getAllSystemUserRoles {
        getAllSystemUserRoles {
            response {
                ${responseField}
            }
            data {
                ${userRoleFields}
            }
        }
    }
`;

export const GET_SYSTEM_PERMISSIONS_QUERY = gql`
    query getAllSystemPermissions {
        getAllSystemPermissions {
            response {
                ${responseField}
            }
            data {
                ${permissionFields}
            }
        }
    }
`;

export const GET_CURRENT_USER_ROLES_QUERY = gql`
    query GetCurrentUserRoles {
        getCurrentUserRoles {
            response {
                ${responseField}
            }
            data {
                ${userRoleFields}
            }
        }
    }
`;